import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ConfirmarAusenciaModalProps {
  show: boolean;
  onHide: () => void;
  onConfirmar: () => void;
  candidatoId: string;
  candidatoNome: string;
}

const ConfirmarAusenciaModal: React.FC<ConfirmarAusenciaModalProps> = ({ show, onHide, onConfirmar, candidatoId, candidatoNome }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Ausência</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Confirma a ausência do(a) candidato(a) <strong>{candidatoNome}</strong> na Heteroidentificação de hoje?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="warning" onClick={onConfirmar}>
          Confirmar Ausência
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmarAusenciaModal;
